// components/LoadingOverlay.tsx
import React from 'react';
import { ModernCard } from './ui/ModernCard.tsx';
import { LoadingSpinner } from './ui/LoadingSpinner.tsx';

interface LoadingOverlayProps {
  loading: boolean;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ loading }) => {
  if (!loading) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm">
      <ModernCard className="p-8">
        <div className="flex items-center space">

        </div>
        </ModernCard>
    </div>
  );
};